import { makeId } from '@/utils/makeId'

export type Candy = {
  id: string
  name: string
  price: number
  quantity: number
  incrementStep: number
}

export const candies: Candy[] = [
  {
    id: makeId(),
    name: 'Brigadeiro',
    price: 1.5,
    quantity: 0,
    incrementStep: 20,
  },
  {
    id: makeId(),
    name: 'Beijinho',
    price: 1.5,
    quantity: 0,
    incrementStep: 20,
  },
  {
    id: makeId(),
    name: 'Ninho®',
    price: 2,
    quantity: 0,
    incrementStep: 20,
  },
  {
    id: makeId(),
    name: 'Ninho® com Nutella®',
    price: 2.5,
    quantity: 0,
    incrementStep: 20,
  },
  // {
  //   id: makeId(),
  //   name: 'Cupcake',
  //   price: 9.99,
  //   quantity: 0,
  //   incrementStep: 20,
  // },
]
